import memoize from 'utils/memoize';
import getDecimalSeparator from '../getDecimalSeparator';

function calculateDiscountPercent(discountedPrice: number, originalPrice: number) {
  return Math.round(100 - (100 * discountedPrice) / originalPrice)
    .toLocaleString()
    .replace(`${getDecimalSeparator()}00`, '');
}

export default memoize(calculateDiscountPercent);
